import { RouteObject } from 'react-router-dom'

import { default as NewVenue } from '.'
import { PageLayout } from '../../../common/app'

export const newVenueRoutes: RouteObject[] = [
  {
    path: '/settings/venues/new',
    element: (
      // htmlTitleOnly: the breadcrumbs render the visual title, and the
      // standard PageHeader would show the reports date filter, which has no
      // meaning here.
      <PageLayout title="Create venue" htmlTitleOnly alignMainContent="center">
        <NewVenue.NewVenue.Component />
      </PageLayout>
    ),
    loader: NewVenue.NewVenue.Loader,
  },
]
